import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

interface StartPropertySpyDialogProps {
    open: boolean,
    onClose: (event: any) => void
    onOk: (event: any) => void
}

export const StartPropertySpyDialog = (props: StartPropertySpyDialogProps): JSX.Element => {
    const {
        open,
        onClose,
        onOk
    } = props

    const handleClose = (event: any) => {
        onClose?.(event)
    }

    const handleOk = (event: any) => {
        onOk?.(event)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" sx={{ fontSize: '24px', fontWeight: '600' }}>
                {"We will spy on this property"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ fontSize: '20px' }}>
                    Once <b>any</b> changes occur you will receive notification and the results will appear under Property Results
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleOk} autoFocus>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    )
}
